"use client";

import { useEffect, useMemo, useState } from "react";

type EvalItem = {
  index: number;
  subvraagId: number;
  vraagId: number;
  stappenplanId: number;
  code: string;
  letter: string;
  leerlijn: string;
  hoofdstuk: string;
  sectie: string;
  difficulty: number;
  answer: number;
  concrete: number;
};

const ITEMS: EvalItem[] = [
  {
    index: 1,
    subvraagId: 7434,
    vraagId: 2783,
    stappenplanId: 1695,
    code: "67",
    letter: "b",
    leerlijn: "G&R 12 HAVO jaar 3",
    hoofdstuk: "H1",
    sectie: "Paragraaf 1.5",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 2,
    subvraagId: 1413,
    vraagId: 404,
    stappenplanId: 157,
    code: "60",
    letter: "b",
    leerlijn: "G&R 12 HAVO A jaar 4,5",
    hoofdstuk: "H9",
    sectie: "Paragraaf 9.4",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 3,
    subvraagId: 5603,
    vraagId: 2032,
    stappenplanId: 992,
    code: "40",
    letter: "b",
    leerlijn: "G&R 12 HAVO B jaar 4,5",
    hoofdstuk: "H8",
    sectie: "Paragraaf 8.3",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 4,
    subvraagId: 18713,
    vraagId: 6110,
    stappenplanId: 2304,
    code: "57",
    letter: "c",
    leerlijn: "G&R 12 VMBOB jaar 3",
    hoofdstuk: "H2",
    sectie: "Paragraaf 2.5",
    difficulty: 3,
    answer: 4,
    concrete: 4
  },
  {
    index: 5,
    subvraagId: 21239,
    vraagId: 7395,
    stappenplanId: 2792,
    code: "22",
    letter: "a",
    leerlijn: "G&R 12 VMBOB jaar 4",
    hoofdstuk: "H8",
    sectie: "Paragraaf 8.1",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 6,
    subvraagId: 31566,
    vraagId: 11340,
    stappenplanId: 3052,
    code: "6",
    letter: "d",
    leerlijn: "G&R 12 VMBOKGT jaar 2",
    hoofdstuk: "H3",
    sectie: "Voorkennis Oppervlakte-eenheden",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 7,
    subvraagId: 39232,
    vraagId: 14487,
    stappenplanId: 3178,
    code: "13",
    letter: "c",
    leerlijn: "G&R 12 VMBOTHAVO jaar 1",
    hoofdstuk: "H6",
    sectie: "Paragraaf 6.2",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 8,
    subvraagId: 43237,
    vraagId: 15837,
    stappenplanId: 3445,
    code: "25",
    letter: "b",
    leerlijn: "G&R 12 VMBOTHAVO jaar 2",
    hoofdstuk: "Hoofdstuk 1 HAVO",
    sectie: "Diagnostische toets & Herhaling",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 9,
    subvraagId: 54623,
    vraagId: 19830,
    stappenplanId: 4221,
    code: "19",
    letter: "c",
    leerlijn: "G&R 12 VWO jaar 1",
    hoofdstuk: "H2",
    sectie: "Paragraaf 2.2",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 10,
    subvraagId: 59408,
    vraagId: 21125,
    stappenplanId: 4534,
    code: "1",
    letter: "b",
    leerlijn: "G&R 12 VWO jaar 2",
    hoofdstuk: "H3",
    sectie: "Diagnostische toets en herhaling",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 11,
    subvraagId: 168220,
    vraagId: 59309,
    stappenplanId: 5011,
    code: "2",
    letter: "c",
    leerlijn: "Moderne Wiskunde 12 VWO A jaar 4,5,6",
    hoofdstuk: "H20",
    sectie: "Paragraaf 20.1",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 12,
    subvraagId: 7418,
    vraagId: 2777,
    stappenplanId: 1679,
    code: "61",
    letter: "c",
    leerlijn: "G&R 12 HAVO jaar 3",
    hoofdstuk: "H1",
    sectie: "Paragraaf 1.5",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 13,
    subvraagId: 226135,
    vraagId: 79330,
    stappenplanId: 185,
    code: "18",
    letter: "b",
    leerlijn: "G&R 12 HAVO A jaar 4,5",
    hoofdstuk: "H6",
    sectie: "Paragraaf 6.1",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 14,
    subvraagId: 5190,
    vraagId: 1890,
    stappenplanId: 608,
    code: "5",
    letter: "b",
    leerlijn: "G&R 12 HAVO B jaar 4,5",
    hoofdstuk: "H7",
    sectie: "Diagnostische toets",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 15,
    subvraagId: 18700,
    vraagId: 6107,
    stappenplanId: 2291,
    code: "54",
    letter: "a",
    leerlijn: "G&R 12 VMBOB jaar 3",
    hoofdstuk: "H2",
    sectie: "Paragraaf 2.5",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 16,
    subvraagId: 21310,
    vraagId: 7463,
    stappenplanId: 2862,
    code: "9",
    letter: "a",
    leerlijn: "G&R 12 VMBOB jaar 4",
    hoofdstuk: "H8",
    sectie: "Paragraaf 8.3",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 17,
    subvraagId: 31534,
    vraagId: 11329,
    stappenplanId: 3020,
    code: "61",
    letter: "a",
    leerlijn: "G&R 12 VMBOKGT jaar 2",
    hoofdstuk: "H3",
    sectie: "Paragraaf 3.5",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 18,
    subvraagId: 39132,
    vraagId: 14458,
    stappenplanId: 3082,
    code: "18",
    letter: "a",
    leerlijn: "G&R 12 VMBOTHAVO jaar 1",
    hoofdstuk: "H6",
    sectie: "Diagnostische toets en herhaling",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 19,
    subvraagId: 43344,
    vraagId: 15859,
    stappenplanId: 3546,
    code: "12",
    letter: "e",
    leerlijn: "G&R 12 VMBOTHAVO jaar 2",
    hoofdstuk: "Hoofdstuk 1 HAVO",
    sectie: "Paragraaf 1.2",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 20,
    subvraagId: 54491,
    vraagId: 19802,
    stappenplanId: 4081,
    code: "1",
    letter: "i",
    leerlijn: "G&R 12 VWO jaar 1",
    hoofdstuk: "H2",
    sectie: "2 Voorkennis Rekenen",
    difficulty: 2,
    answer: 5,
    concrete: 4
  },
  {
    index: 21,
    subvraagId: 59654,
    vraagId: 21212,
    stappenplanId: 4810,
    code: "42",
    letter: "f",
    leerlijn: "G&R 12 VWO jaar 2",
    hoofdstuk: "H3",
    sectie: "Paragraaf 3.4",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 22,
    subvraagId: 168334,
    vraagId: 59346,
    stappenplanId: 5125,
    code: "11",
    letter: "c",
    leerlijn: "Moderne Wiskunde 12 VWO A jaar 4,5,6",
    hoofdstuk: "H20",
    sectie: "Test jezelf",
    difficulty: 4,
    answer: 5,
    concrete: 5
  },
  {
    index: 23,
    subvraagId: 7313,
    vraagId: 2746,
    stappenplanId: 1574,
    code: "30",
    letter: "a",
    leerlijn: "G&R 12 HAVO jaar 3",
    hoofdstuk: "H1",
    sectie: "Paragraaf 1.3",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 24,
    subvraagId: 1793,
    vraagId: 625,
    stappenplanId: 458,
    code: "20",
    letter: "c",
    leerlijn: "G&R 12 HAVO A jaar 4,5",
    hoofdstuk: "H7",
    sectie: "Paragraaf 7.2",
    difficulty: 4,
    answer: 5,
    concrete: 5
  },
  {
    index: 25,
    subvraagId: 5690,
    vraagId: 2056,
    stappenplanId: 1079,
    code: "64",
    letter: "e",
    leerlijn: "G&R 12 HAVO B jaar 4,5",
    hoofdstuk: "H8",
    sectie: "Paragraaf 8.5",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 26,
    subvraagId: 18986,
    vraagId: 6232,
    stappenplanId: 2370,
    code: "2",
    letter: "b",
    leerlijn: "G&R 12 VMBOB jaar 3",
    hoofdstuk: "H4",
    sectie: "D-toets",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 27,
    subvraagId: 21240,
    vraagId: 7396,
    stappenplanId: 2793,
    code: "23",
    letter: "a",
    leerlijn: "G&R 12 VMBOB jaar 4",
    hoofdstuk: "H8",
    sectie: "Paragraaf 8.1",
    difficulty: 2,
    answer: 5,
    concrete: 4
  },
  {
    index: 28,
    subvraagId: 31404,
    vraagId: 11244,
    stappenplanId: 2864,
    code: "1",
    letter: "b",
    leerlijn: "G&R 12 VMBOKGT jaar 2",
    hoofdstuk: "H3",
    sectie: "Diagnostische toets & Herhaling",
    difficulty: 3,
    answer: 5,
    concrete: 5
  },
  {
    index: 29,
    subvraagId: 39235,
    vraagId: 14487,
    stappenplanId: 3181,
    code: "13",
    letter: "f",
    leerlijn: "G&R 12 VMBOTHAVO jaar 1",
    hoofdstuk: "H6",
    sectie: "Paragraaf 6.2",
    difficulty: 2,
    answer: 5,
    concrete: 5
  },
  {
    index: 30,
    subvraagId: 43241,
    vraagId: 15837,
    stappenplanId: 3449,
    code: "25",
    letter: "f",
    leerlijn: "G&R 12 VMBOTHAVO jaar 2",
    hoofdstuk: "Hoofdstuk 1 HAVO",
    sectie: "Diagnostische toets & Herhaling",
    difficulty: 3,
    answer: 5,
    concrete: 5
  }
];

type Status = "idle" | "loading" | "ok" | "error";

type ComparisonEntry = {
  stap: number | null;
  vraag: string;
  antwoord: string;
  difficulty: number | null;
  answer: number | null;
  concrete: number | null;
  tooEasy: boolean;
  tooHard: boolean;
  notes: string;
};

type Comparison = {
  before?: ComparisonEntry;
  after?: ComparisonEntry;
};

const DEFAULT_ITEM = ITEMS.find((item) => item.subvraagId === 1413) ?? ITEMS[0];

export default function AfsluiterCheckPage() {
  const [selectedId, setSelectedId] = useState(DEFAULT_ITEM.subvraagId);
  const [loginStatus, setLoginStatus] = useState<Status>("idle");
  const [warmStatus, setWarmStatus] = useState<Status>("idle");
  const [previewNonce, setPreviewNonce] = useState(0);
  const [comparisons, setComparisons] = useState<Record<number, Comparison>>(
    {}
  );
  const [comparisonStatus, setComparisonStatus] = useState<Status>("loading");
  const selected = useMemo(
    () => ITEMS.find((item) => item.subvraagId === selectedId) ?? ITEMS[0],
    [selectedId]
  );
  const route = `/library/vraag/${selected.vraagId}/${selected.letter}`;
  const previewRoute = `${route}?afsluiter_check=${previewNonce}`;
  const reloadPreview = () => setPreviewNonce((nonce) => nonce + 1);
  const comparison = comparisons[selected.subvraagId];

  useEffect(() => {
    let cancelled = false;

    const loadComparisons = async () => {
      try {
        const response = await fetch("/dev/afsluiter-check/comparisons");
        if (!response.ok) throw new Error("Failed to load comparisons");
        const data = (await response.json()) as {
          comparisons?: Record<number, Comparison>;
        };
        if (!cancelled) {
          setComparisons(data.comparisons ?? {});
          setComparisonStatus("ok");
        }
      } catch {
        if (!cancelled) setComparisonStatus("error");
      }
    };

    void loadComparisons();

    return () => {
      cancelled = true;
    };
  }, []);

  const login = async () => {
    setLoginStatus("loading");
    try {
      const response = await fetch("/api/development/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: "janpieter@gmaiil.com" })
      });
      setLoginStatus(response.ok ? "ok" : "error");
      if (response.ok) reloadPreview();
    } catch {
      setLoginStatus("error");
    }
  };

  const warmAfsluiter = async () => {
    setWarmStatus("loading");
    try {
      const response = await fetch("/api/hwm/afsluiter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subvraag_id: selected.subvraagId })
      });
      setWarmStatus(response.ok ? "ok" : "error");
      if (response.ok) reloadPreview();
    } catch {
      setWarmStatus("error");
    }
  };

  return (
    <main className="h-screen overflow-hidden bg-slate-100 text-slate-950">
      <div className="grid h-full grid-cols-[390px_1fr]">
        <aside className="flex min-h-0 flex-col border-r border-slate-200 bg-white">
          <div className="border-b border-slate-200 p-4">
            <h1 className="text-lg font-semibold">Afsluiter check</h1>
            <p className="mt-1 text-sm leading-5 text-slate-600">
              30 eval cases, sampled uniformly over all detected leerlijnen. The
              preview uses the normal WisWiz library route.
            </p>
            <div className="mt-4 grid grid-cols-2 gap-2">
              <button
                onClick={login}
                className="rounded-md bg-slate-950 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800"
              >
                Dev login
              </button>
              <button
                onClick={warmAfsluiter}
                className="rounded-md border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
              >
                Warm selected
              </button>
            </div>
            <div className="mt-2 flex gap-3 text-xs text-slate-500">
              <span>login: {loginStatus}</span>
              <span>afsluiter: {warmStatus}</span>
            </div>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto p-2">
            {ITEMS.map((item) => {
              const active = item.subvraagId === selected.subvraagId;
              return (
                <button
                  key={item.subvraagId}
                  onClick={() => {
                    setSelectedId(item.subvraagId);
                    setWarmStatus("idle");
                    reloadPreview();
                  }}
                  className={`mb-2 block w-full rounded-md border p-3 text-left text-sm transition ${
                    active
                      ? "border-slate-950 bg-slate-950 text-white"
                      : "border-slate-200 bg-white hover:border-slate-400"
                  }`}
                >
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-semibold">
                      {item.index}. Vraag {item.code}
                      {item.letter}
                    </span>
                    <span
                      className={active ? "text-slate-200" : "text-slate-500"}
                    >
                      D{item.difficulty} A{item.answer}
                    </span>
                  </div>
                  <div
                    className={
                      active ? "mt-1 text-slate-200" : "mt-1 text-slate-600"
                    }
                  >
                    {item.leerlijn}
                  </div>
                  <div
                    className={
                      active ? "mt-1 text-slate-300" : "mt-1 text-slate-500"
                    }
                  >
                    {item.hoofdstuk} · {item.sectie}
                  </div>
                </button>
              );
            })}
          </div>
        </aside>

        <section className="flex min-w-0 flex-col">
          <div className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3">
            <div>
              <div className="text-sm font-semibold">
                {selected.index}. Vraag {selected.code}
                {selected.letter}
              </div>
              <div className="text-xs text-slate-500">
                subvraag {selected.subvraagId} · stappenplan{" "}
                {selected.stappenplanId} · {selected.leerlijn}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a
                href={route}
                target="_blank"
                className="rounded-md border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
              >
                Open route
              </a>
              <button
                onClick={reloadPreview}
                className="rounded-md border border-slate-300 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
              >
                Reload
              </button>
            </div>
          </div>
          <BeforeAfterPanel
            comparison={comparison}
            comparisonStatus={comparisonStatus}
          />
          <iframe
            id="afsluiter-preview"
            key={previewRoute}
            src={previewRoute}
            className="h-full w-full flex-1 bg-white"
          />
        </section>
      </div>
    </main>
  );
}

function BeforeAfterPanel({
  comparison,
  comparisonStatus
}: {
  comparison?: Comparison;
  comparisonStatus: Status;
}) {
  return (
    <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
      <div className="mb-2 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-sm font-semibold">Before / after begripvraag</h2>
          <p className="text-xs text-slate-500">
            Eval output: old prompt versus selected new prompt. Live preview
            below uses the regular frontend.
          </p>
        </div>
        <div className="text-xs text-slate-500">
          comparison: {comparisonStatus}
        </div>
      </div>
      {comparison ? (
        <div className="grid max-h-64 grid-cols-2 gap-3 overflow-y-auto">
          <ComparisonCard label="Before" entry={comparison.before} />
          <ComparisonCard label="After" entry={comparison.after} highlight />
        </div>
      ) : (
        <div className="rounded-md border border-dashed border-slate-300 bg-white px-3 py-4 text-sm text-slate-500">
          No comparison loaded for this case.
        </div>
      )}
    </div>
  );
}

function ComparisonCard({
  label,
  entry,
  highlight = false
}: {
  label: string;
  entry?: ComparisonEntry;
  highlight?: boolean;
}) {
  if (!entry) {
    return (
      <div className="rounded-md border border-slate-200 bg-white p-3 text-sm text-slate-500">
        {label}: missing
      </div>
    );
  }

  const flags = [
    entry.tooEasy ? "too easy" : null,
    entry.tooHard ? "too hard" : null
  ].filter(Boolean);

  return (
    <div
      className={`rounded-md border bg-white p-3 text-sm ${
        highlight ? "border-emerald-300" : "border-slate-200"
      }`}
    >
      <div className="mb-2 flex items-center justify-between gap-3">
        <div className="font-semibold">{label}</div>
        <div className="text-xs text-slate-500">
          stap {entry.stap ?? "-"} · D{entry.difficulty ?? "-"} A
          {entry.answer ?? "-"} C{entry.concrete ?? "-"}
        </div>
      </div>
      <div className="space-y-2 leading-5">
        <div>
          <div className="text-xs font-semibold uppercase text-slate-500">
            Vraag
          </div>
          <div>{entry.vraag}</div>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase text-slate-500">
            Antwoord
          </div>
          <div>{entry.antwoord}</div>
        </div>
        <div className="text-xs text-slate-500">
          {flags.length > 0 ? `${flags.join(", ")} · ` : ""}
          {entry.notes}
        </div>
      </div>
    </div>
  );
}
